import curry from "../../lib/core/functional/curry";
import { verifyOtp } from "../../transport/loginSignupV2";
import { doUpgradeToLoggedIn } from "../../upgradeToLoggedInLoader";

function onLoginSuccess(wrapper, context){
    const otpBox = wrapper.closest(".login-signup-wrapper");
    otpBox.parentNode.removeChild(otpBox);
    doUpgradeToLoggedIn(context);
}

function errorFeedback(wrapper){
    wrapper.classList.remove("hidden");
}

function processResponse(wrapper, errorContainer, context, response){
    if (response && typeof response === 'object' && Object.keys(response).length === 0){
        return onLoginSuccess(wrapper, context);
    }

    return errorFeedback(errorContainer);
}

export const validateOtp = curry((context, event) => {
    const wrapper = event.currentTarget;
    const otp = wrapper.querySelector("#id_otp").value.trim();
    const errorContainer = wrapper.querySelector(".comment--login--message.error");

    event.preventDefault();

    function handleResponse(response) {
        processResponse(wrapper, errorContainer, context, response);
    }

    verifyOtp({ code: otp })
        .then(handleResponse)
        .catch(() => errorFeedback(errorContainer))
});
